import React from "react";
import { Route, Switch } from "react-router-dom";
import ScrollToTop from "./hooks/ScrollToTop";
import useTracking from "./hooks/useTracking";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import JobsContext from "./context/JobsContext";

import Home from "./pages/Home";
import OpenSollicitatie from "./pages/OpenSollicitatie";
import Page404 from "./pages/Page404";
import Elektromonteur from "./pages/jobs/Elektromonteur";
import AccountManagerZonnepanelen from "./pages/jobs/AccountManagerZonnepanelen";
import VerkoopBinnendienst from "./pages/jobs/VerkoopBinnendienst";
import VerkoopBinnendienst24uur from "./pages/jobs/VerkoopBinnendienst24uur";
import HulpMonteurElektrotechniek from "./pages/jobs/HulpMonteurElektrotechniek";
import MagazijnMedewerker from "./pages/jobs/MagazijnMedewerker";
import TekenaarWerkvoorbereiderInstallatietechniek from "./pages/jobs/TekenaarWerkvoorbereiderInstallatietechniek";
import WerkvoorbereiderElektromonteur from "./pages/jobs/WerkvoorbereiderElektromonteur";
import WerkvoorbereiderPlanner from "./pages/jobs/WerkvoorbereiderPlanner";
import AfterSalesCoordinator from "./pages/jobs/AfterSalesCoordinator";
import AdministratiefMedewerkerInkoop from "./pages/jobs/AdministratiefMedewerkerInkoop";
import CommercieelMedewerkerBinnendienst from "./pages/jobs/CommercieelMedewerkerBinnendienst";
import Werkvoorbereider from "./pages/jobs/Werkvoorbereider";
import InspecteurScope12 from "./pages/jobs/InspecteurScope12";

import "./scss/style.scss";

function App() {
    useTracking("UA-65727447-11");
    const jobs = {
        accountManagerZonnepanelen: false,
        administratiefMedewerkerInkoop: false,
        afterSalesCoordinator: false,
        commercieelMedewerkerBinnendienst: true,
        verkoopBinnendienst: false,
        verkoopBinnendienst24uur: false,
        elektromonteur: true,
        hulpMonteurElektrotechniek: false,
        magazijnMedewerker: false,
        werkvoorbereiderElektromonteur: false,
        werkvoorbereiderPlanner: false,
        tekenaarWerkvoorbereiderInstallatietechniek: false,
        werkvoorbereider: false,
        inspecteurScope12: false,
    };
    return (
        <JobsContext.Provider value={jobs}>
            <div className="d-flex flex-column" style={{ minHeight: "100svh" }}>
                <div className="flex-grow-1">
                    <Navbar />

                    <main id="main-content" tabIndex="-1">
                        <ScrollToTop />
                        <Switch>
                            <Route path="/" exact>
                                <Home />
                            </Route>
                            <Route path="/open-sollicitatie" exact>
                                <OpenSollicitatie />
                            </Route>
                            {jobs.accountManagerZonnepanelen && (
                                <Route
                                    path="/vacature/account-manager-zonnepanelen"
                                    exact
                                >
                                    <AccountManagerZonnepanelen />
                                </Route>
                            )}
                            {jobs.administratiefMedewerkerInkoop && (
                                <Route
                                    path="/vacature/administratief-medewerker-inkoop"
                                    exact
                                >
                                    <AdministratiefMedewerkerInkoop />
                                </Route>
                            )}
                            {jobs.afterSalesCoordinator && (
                                <Route
                                    path="/vacature/after-sales-coordinator"
                                    exact
                                >
                                    <AfterSalesCoordinator />
                                </Route>
                            )}
                            {jobs.commercieelMedewerkerBinnendienst && (
                                <Route
                                    path="/vacature/commercieel-medewerker-binnendienst"
                                    exact
                                >
                                    <CommercieelMedewerkerBinnendienst />
                                </Route>
                            )}
                            {jobs.verkoopBinnendienst && (
                                <Route
                                    path="/vacature/verkoop-binnendienst"
                                    exact
                                >
                                    <VerkoopBinnendienst />
                                </Route>
                            )}
                            {jobs.verkoopBinnendienst24uur && (
                                <Route
                                    path="/vacature/verkoop-binnendienst-24-uur"
                                    exact
                                >
                                    <VerkoopBinnendienst24uur />
                                </Route>
                            )}
                            {jobs.elektromonteur && (
                                <Route path="/vacature/elektromonteur" exact>
                                    <Elektromonteur />
                                </Route>
                            )}
                            {jobs.hulpMonteurElektrotechniek && (
                                <Route
                                    path="/vacature/hulp-monteur-elektrotechniek"
                                    exact
                                >
                                    <HulpMonteurElektrotechniek />
                                </Route>
                            )}
                            {jobs.magazijnMedewerker && (
                                <Route
                                    path="/vacature/magazijnmedewerker"
                                    exact
                                >
                                    <MagazijnMedewerker />
                                </Route>
                            )}
                            {jobs.werkvoorbereiderElektromonteur && (
                                <Route
                                    path="/vacature/werkvoorbereider-elektromonteur"
                                    exact
                                >
                                    <WerkvoorbereiderElektromonteur />
                                </Route>
                            )}
                            {jobs.werkvoorbereiderPlanner && (
                                <Route
                                    path="/vacature/werkvoorbereider-planner"
                                    exact
                                >
                                    <WerkvoorbereiderPlanner />
                                </Route>
                            )}
                            {jobs.tekenaarWerkvoorbereiderInstallatietechniek && (
                                <Route
                                    path="/vacature/tekenaar-werkvoorbereider-installatietechniek"
                                    exact
                                >
                                    <TekenaarWerkvoorbereiderInstallatietechniek />
                                </Route>
                            )}
                            {jobs.werkvoorbereider && (
                                <Route path="/vacature/werkvoorbereider" exact>
                                    <Werkvoorbereider />
                                </Route>
                            )}
                            {jobs.inspecteurScope12 && (
                                <Route
                                    path="/vacature/inspecteur-zonnepanelen-scope-12"
                                    exact
                                >
                                    <InspecteurScope12 />
                                </Route>
                            )}
                            <Route path="/">
                                <Page404 />
                            </Route>
                        </Switch>
                    </main>
                </div>
                <Footer />
            </div>
        </JobsContext.Provider>
    );
}

export default App;
